import convert from 'color-convert';

export type Vector = { x: number; y: number; z: number };

export function hexToVector(color: string): Vector {
  const r = parseInt(`${color[1]}${color[2]}`, 16);
  const g = parseInt(`${color[3]}${color[4]}`, 16);
  const b = parseInt(`${color[5]}${color[6]}`, 16);
  return {
    x: r,
    y: g,
    z: b,
  };
}

const distance = (v: Vector, w: Vector): number =>
  Math.sqrt((v.x - w.x) ** 2 + (v.y - w.y) ** 2 + (v.z - w.z) ** 2);

const whiteThreshold = 95;
const blackThreshold = 16;

const getHSLDistance = (a: number[], b: number[]): number => {
  const v: Vector = { x: a[0], y: a[1], z: 0 };
  const w: Vector = { x: b[0], y: b[1], z: 0 };

  return distance(v, w);
};

export function findClosestHueColorIndexFromList(
  color: string,
  colorList: string[],
): number | undefined {
  if (colorList.length === 0) {
    return undefined;
  }

  /**
   * c[0] = h
   * c[1] = s
   * c[2] = l
   */

  const colorHSL = convert.hex.hsl(color);
  const colorListHSLs = colorList.map(c => convert.hex.hsl(c));

  let closestColorIndex = colorList.length - 1;
  let closestDistance = getHSLDistance(
    colorHSL,
    colorListHSLs[colorList.length - 1],
  );

  const black = colorListHSLs.findIndex(c => c[2] < blackThreshold);
  const white = colorListHSLs.findIndex(c => c[2] > whiteThreshold);

  if (black !== -1 && colorHSL[2] <= blackThreshold && colorHSL[1] < 20) {
    return black;
  }

  if (white !== -1 && colorHSL[2] >= whiteThreshold) {
    return white;
  }

  colorListHSLs.forEach((c, index) => {
    if (index === white || index === black) {
      return;
    }

    const d = getHSLDistance(colorHSL, c);

    if (d <= closestDistance) {
      closestDistance = d;
      closestColorIndex = index;
    }
  });

  return closestColorIndex;
}
